// extracted by mini-css-extract-plugin
export default {"error":"error_error__Lc26m","error__content":"error_error__content__fURUh"};